module.exports = __webpack_public_path__ + "assets/img/favicons/favicon-96x96.png";